
				var addMethods = require("../../../external/pwa_npm/node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["toString","fromString","toBase64","fromBase64","pad","unpad","generateSalt","computeHash","generateNonce","encryptMessage","decryptMessage","nonceBase64Length","joinNonceCipher","splitNonceCipher"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "902a4f20663e2eac7694.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			